import * as consts from '../constants';
import initialState from './initialState';

export default function emissionReducer(state = initialState.emissionState, action) {
    switch (action.type) {
        case consts.ACTONS.UPDATE_CONTRAENTE:
            return Object.assign({}, state, action.emissionState);
        case consts.ACTONS.SAVE_CONTRACT_SUCCESS:
            return Object.assign({}, state, action.contract);

        default:
            return state;
    }
}